// components/DeclineVisitModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const DECISION_OPTIONS = [
  { value: 'decline', label: 'Скасувати зустріч' },
  { value: 'success', label: 'Зустріч відбулась' },
  { value: 'not_visit', label: 'Не з\'явились на зустріч' },
  { value: 'reschedule', label: 'Запропонувати інший час' }
];

export const DeclineVisitModal = ({ show, onClose, onSave }) => {
  const [decision, setDecision] = useState('');
  const [description, setDescription] = useState('');

  const handleSave = () => {
    onSave(decision, description);
    setDecision('');
    setDescription('');
  };

  const handleClose = () => {
    setDecision('');
    setDescription('');
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Запис на прийом відвідувача</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Рішення по зустрічі</Form.Label>
            <Form.Select
              value={decision}
              onChange={(e) => setDecision(e.target.value)}
              className="w-50"
            >
              <option value="">Оберіть рішення...</option>
              {DECISION_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label className="fw-bold">Додайте короткий опис</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Введіть опис..."
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="link" onClick={handleClose} className="text-decoration-none">
          Скасувати
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!decision || !description}
        >
          Зафіксувати
        </Button>
      </Modal.Footer>
    </Modal>
  );
};